import type { CalculatorContext } from '@/types/calculator'
import { roundCents } from '@/utils/money'
import type { FuelCostInputs, FuelCostResult } from './types'

const multipliers: Record<FuelCostInputs['period'], number> = {
  day: (365 / 7) * 5,
  week: 52,
  month: 12,
  year: 1,
}

export function calculateFuelCost(
  inputs: FuelCostInputs,
  _context: CalculatorContext
): FuelCostResult {
  const litresPerTrip = inputs.distanceKm * (inputs.consumptionLPer100km / 100)
  const costPerTrip = litresPerTrip * inputs.fuelPricePerLitre
  const periodMultiplier = multipliers[inputs.period]

  const litresPerPeriod = litresPerTrip * inputs.tripsPerPeriod
  const costPerPeriod = litresPerPeriod * inputs.fuelPricePerLitre

  const tripsPerYear = inputs.tripsPerPeriod * periodMultiplier
  const annualLitres = litresPerTrip * tripsPerYear
  const annualCost = annualLitres * inputs.fuelPricePerLitre

  return {
    litresPerTrip: roundCents(litresPerTrip),
    costPerTrip: roundCents(costPerTrip),
    periodMultiplier,
    litresPerPeriod: roundCents(litresPerPeriod),
    costPerPeriod: roundCents(costPerPeriod),
    annualLitres: roundCents(annualLitres),
    annualCost: roundCents(annualCost),
  }
}
